import React from 'react';
import ReactDOM from 'react-dom';
import './css/variables.css';
import './css/fonts.css';
import './css/base.css';
import './css/scrollbar.css';
import './css/calendar.css';
import './css/mui-overrides.css';
import './css/buttons.css';
import './css/status-classes.css';
import './css/utility-classes.css';
import './css/list-components.css';
import './css/icons.css';
import './css/disputes.css';
import App from './App';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import {LocalizationProvider} from '@mui/x-date-pickers';
import 'react-date-range/dist/styles.css'; // main css file
import 'react-date-range/dist/theme/default.css'; // theme css file
ReactDOM.render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <App />
    </LocalizationProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

